export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/51979657270"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform z-50 animate-pulse cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl sm:text-3xl text-white"></i>
    </a>
  );
}